import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton, IonCard, IonIcon} from '@ionic/react';
import {checkmarkCircle} from 'ionicons/icons'
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import axiosInstance from '../services/AxiosInstance';

import './css/general.css';
import styles from './css/Feedback.module.css';

interface FeedbackProps extends RouteComponentProps {
    // Define the props here
  }
  
  interface FeedbackState {
    // Define the state here
    message: string,
  }
  
  const token = localStorage.getItem("token");
  
  class Feedback extends React.Component<FeedbackProps, FeedbackState> {
    constructor(props: FeedbackProps) {
      super(props);
  
      this.state = {
        message: "",
      };

      this.getData()
    }

    async getData(){
      let subjects = false;
      var id = await localStorage.getItem("id");

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axiosInstance
      .get("/UserSubjects/" + id, config)
      .then((resp) => {
        if(resp.data.userSubjects == undefined)
        {
          alert("Pas op! Je kan pas feedback naar je bedrijf sturen eens je ingeschreven bent voor een casus!");
          const {history} = this.props;
          history.go(-1);
        }
        subjects = (resp.data.userSubjects.length > 0)

        //console.log(subjects);
        if(!subjects)
        {
          alert("Pas op! Je kan pas feedback naar je bedrijf sturen eens je ingeschreven bent voor een casus!");
          const {history} = this.props;
          history.go(-1);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    };
  
    submitFeedback(){
    var employeeId = localStorage.getItem("id");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let regExp = /[a-zA-Z]/g;

    //console.log(this.state.message)

    if (regExp.test(this.state.message)) {
      axiosInstance
        .post(
          "/Feedbacks/admin",
          {
            Message: this.state.message,
            UserId: employeeId,
          },
          config
        )
        .then((error) => {
          console.log(error);
        });

      // toon popup
      this.showPopup()
    } else {
      alert("Pas op! Je kan geen lege berichten versturen.");
    }
      }
    
    showPopup(){
      let popup = document.getElementById("popup");
      if(popup != null){
          popup.style.display = "block";
      }
    
    }
    
    goBack(){
      const {history} = this.props;
      history.go(-1);
    }

    render(){
        return(
            <IonPage>
                <IonHeader>
                    <IonToolbar class="ion-no-border">
                    <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                        <IonTitle>Feedback</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen>
                  <div className="whiteBG">
                      <div className={(styles.feedback)}>
                          <h1>Feedback</h1>
                          <p className={(styles.feedbackText)}>Heb je suggesties voor onze administrators? <br/> Laat het ons zeker weten!</p>
                          <input 
                          name="feedback" 
                          className={(styles.inputFeedback)} 
                          placeholder="Schrijf hier je boodschap"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>)=> this.setState({message: e.target.value})}
                          />
                      </div>
                      <IonButton shape="round" size= "large" onClick={() => this.submitFeedback()}>Verzenden</IonButton>


                      {/* popup */}
                    <IonCard className={(styles.popupSubmitted)} id="popup">
                    <IonIcon icon={checkmarkCircle} className={(styles.checkIcon)}></IonIcon>
                      <p>Bedankt!</p>
                      <p>Je feedback is met succes verzonden.</p>
                      <button className={(styles.btn)} onClick={() => this.goBack()}>Begrepen</button>
                    </IonCard>
                  </div>
              </IonContent>
            </IonPage>
        );
    }
};

export default withRouter(Feedback);
